import { useLayoutEffect } from "react";

const navBarheight = 50;
const footerHeight = 24;
const offset = 10;
export const calculateGridHeight = (
  topPanelRef,
  setHeight,
  additionalOffset = 0
) => {
  if (!topPanelRef?.current) return;

  const topPanelHeight = topPanelRef.current.offsetHeight || 0;
  const viewportHeight = window.innerHeight;

  setHeight(
    viewportHeight -
      topPanelHeight -
      navBarheight -
      footerHeight -
      offset -
      additionalOffset
  );
};
export default function useGridResizeHook(resizeEvent) {
  useLayoutEffect(() => {
    resizeEvent();
    window.addEventListener("resize", resizeEvent);
    return () => {
      window.removeEventListener("resize", resizeEvent);
    };
  }, [resizeEvent]);
}
